import { Injectable, inject } from '@angular/core';

import { LoaderStylesService } from '@frontend/loaders';
import {
    BetslipOnboardingConfig,
    BetslipUpsellConfig,
    LineSwitcherConfig,
    NotificationsConfig,
    OverAskConfig,
    SportsUserSettings,
    TeaserBetConfig,
} from '@frontend/sports/common/client-config-data-access';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';
import { Observable, forkJoin, from, map, of } from 'rxjs';

import type { BetslipDigitalModule } from '../digital/betslip-digital.module';

@Injectable()
export class BetslipDigitalModuleLoaderService {
    private readonly moduleLoader = inject(ModuleLoaderService);
    private readonly sportsUserSettings = inject(SportsUserSettings);
    private readonly lineSwitcherConfig = inject(LineSwitcherConfig);
    private readonly betslipOnboardingConfig = inject(BetslipOnboardingConfig);
    private readonly betslipUpsellConfig = inject(BetslipUpsellConfig);
    private readonly overAskConfig = inject(OverAskConfig);
    private readonly notificationsConfig = inject(NotificationsConfig);
    private readonly teaserBetConfig = inject(TeaserBetConfig);
    private readonly styles = inject(LoaderStylesService);

    loadedStyles = from(this.styles.loadStyles([{ id: 'sports-betslip', type: 'theme' }]));
    moduleRef: BetslipDigitalModule;

    loadBetslipModule(): Observable<BetslipDigitalModule> {
        if (this.moduleRef) {
            return of(this.moduleRef);
        }

        return forkJoin([
            this.loadedStyles,
            this.moduleLoader.loadModule<BetslipDigitalModule>(
                'BetslipDigitalModule',
                () => import('../digital/betslip-digital.module').then((module) => module.BetslipDigitalModule),
                this.sportsUserSettings,
                this.lineSwitcherConfig,
                this.betslipOnboardingConfig,
                this.betslipUpsellConfig,
                this.overAskConfig,
                this.notificationsConfig,
                this.teaserBetConfig,
            ),
        ]).pipe(
            map(([_, moduleRef]) => {
                this.moduleRef = moduleRef.instance;
                return this.moduleRef;
            }),
        );
    }
}
